// client/src/pages/Home.js
import React, { useContext, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { AuthContext } from '../context/AuthContext';
import HomeComponent from '../components/HomeComponent';
import '../styles/Home.css';

function Home() {
  const { isAuthenticated, token } = useContext(AuthContext);
  const loggedIn = Boolean(token || isAuthenticated);
  const videoRef = useRef(null);

  // Start the demo video only once it scrolls into view
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(() => {});
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Helmet>
        <title>DynaStoxx - Intelligente Aktienanalyse & Portfolio-Management</title>
        <meta name="description" content="Finde unterbewertete Aktien mit über 20 Filtern, analysiere Kennzahlen wie KGV, KBV und Dividendenrendite und verfolge dein Portfolio – kostenlos bei DynaStoxx." />
        <link rel="canonical" href="https://dynastoxx.com/" />
        <meta property="og:title" content="DynaStoxx - Intelligente Aktienanalyse" />
        <meta property="og:description" content="Aktien finden, analysieren und dein Portfolio verfolgen." />
        <meta property="og:url" content="https://dynastoxx.com/" />
      </Helmet>

      <div className="home-container">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="home-inner">
            <p className="hero-eyebrow">Value Investing leicht gemacht</p>
            <h1>Intelligente Aktienanalyse &amp; Portfolio-Management</h1>
            <p className="hero-subtitle">
              Entdecke, analysiere und verfolge Aktien für dein Portfolio – mit Kennzahlen, die wirklich zählen.
            </p>
            <div className="hero-buttons">
              <Link to="/search" className="home-btn home-btn--primary">
                <i className="fas fa-search" aria-hidden="true"></i>
                Suche starten
              </Link>
              {!loggedIn && (
                <Link to="/login" className="home-btn home-btn--secondary">
                  <i className="fas fa-user" aria-hidden="true"></i>
                  Anmelden
                </Link>
              )}
            </div>

            <div className="hero-video-container">
              <video
                ref={videoRef}
                muted
                loop
                playsInline
                controls
                preload="metadata"
                className="hero-video"
                aria-label="Demo der DynaStoxx App"
              >
                <source src="/app-demo.mp4#t=0.1" type="video/mp4" />
                Dein Browser unterstützt das Video-Tag nicht.
              </video>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <div className="home-inner">
            <HomeComponent />
          </div>
        </section>
      </div>
    </>
  );
}

export default Home;
